const handleCloseDialogModalEquipService = {
  confirm: 'Suas informações não salvas serão perdidas.',
  title: 'Sair?',
}

export default handleCloseDialogModalEquipService;
